import React, { useState, useEffect } from "react";
import ActivePickupStep from "./ActivePickupStep";
import ActiveDropoffStep from "./ActiveDropoffStep";
import { CircleCheck } from "lucide-react";
import { theme } from "../assets/theme/theme";
import { decryptData } from "../utils/storageCrypto";


const ActiveRidePage = ({
  activeRide,
  GetRideDetails,
  mobile,
  onGetNewRides,
  onFinalStepComplete,
}) => {
  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(null);
  const [isThisLastStep, setIsThisLastStep] = useState(false);
  const [rideCompleted, setRideCompleted] = useState(false);

  useEffect(() => {
    if (activeRide?.steps?.length) {
      setSteps(activeRide.steps);
      const allDone = activeRide.steps.every((s) => s.status === "COMPLETED");
      if (allDone) {
        setRideCompleted(true);
      }
    } else {
      setSteps([]);
    }
  }, [activeRide]);

  useEffect(() => {
    if (!steps.length) {
      setCurrentStep(null);
      return;
    }

    const nextStep = steps.find((step) => step.status !== "COMPLETED");
    setCurrentStep(nextStep || null);
    setIsThisLastStep(
      nextStep ? steps.indexOf(nextStep) === steps.length - 1 : false
    );
  }, [steps]);

/*   const handleStepCompleted = async () => {
    if (isThisLastStep) {
      onFinalStepComplete?.();
      setRideCompleted(true);
    } else {
      setRideCompleted(false);
      await GetRideDetails(mobile);
    }
  }; */


  const handleStepCompleted = async () => {
    if (isThisLastStep) {
      try {
        const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
        const encryptedToken = sessionStorage.getItem("token");
        const token = decryptData(encryptedToken);

        await fetch(`${URL}delivery/end-trip`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
          body: JSON.stringify({
            trip_id: activeRide.tripId,
          }),
        });
      } catch (error) {
        console.error("Failed to end trip:", error);
      }

      onFinalStepComplete?.();
      setRideCompleted(true);
    } else {
      setRideCompleted(false);
      await GetRideDetails(mobile);
    }
  };

  if (rideCompleted) {
    return (
      <div className="h-full flex flex-col justify-center items-center py-6">
        <div
          className="w-full p-8 text-center border shadow-sm"
          style={{
            backgroundColor: theme.colors.pureWhite,
            borderColor: theme.colors.grey002,
            borderRadius: `${theme.radius[24]}px`,
          }}
        >
          <div
            className="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center shadow-md animate-bounce"
            style={{
              backgroundColor: theme.colors.offWhite,
              border: `1px solid ${theme.colors.grey002}`,
            }}
          >
            <CircleCheck className="w-8 h-8 text-black" />
          </div>

          <h2
            className="text-2xl font-bold"
            style={{
              fontFamily: "BarlowCondensed-Bold",
              color: theme.colors.bitumen,
            }}
          >
            Trip Completed
          </h2>

          <p
            className="text-xs mt-1 mb-6 max-w-xs mx-auto"
            style={{
              fontFamily: "DMSans-Regular",
              color: theme.colors.concrete,
            }}
          >
            Trip  {activeRide?.shipmentNumber || activeRide?.shipmentId} has been successfully completed.
          </p>

          <button
            onClick={onGetNewRides}
            className="w-full py-4 text-white font-bold transition-all shadow-md active:scale-[0.99] cursor-pointer"
            style={{
              fontFamily: "DMSans-Medium",
              borderRadius: `${theme.radius[16]}px`,
              backgroundColor: theme.colors.brand,
              boxShadow: `0 4px 14px ${theme.colors.brand}40`,
            }}
          >
            Find New Trips
          </button>
        </div>
      </div>
    );
  }

const totalPickups = steps.filter(s => s.type === "PICKUP").length;
const totalDropoffs = steps.filter(s => s.type === "DROPOFF").length;

  return (
    <div className="space-y-3">

    <div className="bg-white border rounded-xl p-3 flex justify-between items-center shadow-sm" style={{ borderColor: theme.colors.grey002 }}>
      <div>
        <p className="text-xs text-gray-500 font-medium">Trip Fare</p>
        <p className="font-bold text-lg text-gray-900">₹{activeRide?.earnings || "0"}</p>
        <p className="text-[10px] text-gray-400 mt-0.5">{activeRide?.totalDistance || "0"} Kms total</p>
      </div>
      <div className="text-right flex flex-col gap-1">
        <span className="text-xs font-bold text-blue-600 bg-blue-50 px-2 py-1 rounded-md">{totalPickups} Pickups ⬆</span>
        <span className="text-xs font-bold text-green-600 bg-green-50 px-2 py-1 rounded-md">{totalDropoffs} Dropoffs ⬇</span>
      </div>
    </div>

      {currentStep?.type === "PICKUP" && (
        <ActivePickupStep
          step={currentStep}
          totalStepsCount={steps.length}
          onComplete={handleStepCompleted}
          activeRide={activeRide}
          isLastStep={isThisLastStep}
        />
      )}

      {currentStep?.type === "DROPOFF" && (
        <ActiveDropoffStep
          step={currentStep}
          totalStepsCount={steps.length}
          onComplete={handleStepCompleted}
          activeRide={activeRide}
          isLastStep={isThisLastStep}
        />
      )}
    </div>
  );
};

export default ActiveRidePage;